/**
 * @author       denys.yefremov@startupsoft.co (Denys Yefremov)
 * @copyright    Copyright (c) 2022, Zumper
 */

import { payloadReducer } from '@zcode/reducers'
import type { PermanentAddressMessage } from '@zcode/state-type'
import { combineReducers } from 'redux'
import { type ExtractActions, type Values, handleAction } from 'redux-actions'
import type * as actions from '../actions'
import { SET_MESSAGE_ACTIVE_LISTING_ID, SET_MESSAGE_LISTING_DETAILS } from '../constants'
import { metaReducer } from './meta'

type Actions = ExtractActions<Values<typeof actions>>

export const messageReducer = combineReducers<PermanentAddressMessage, Actions>({
  selectedListingId: handleAction<
    PermanentAddressMessage['selectedListingId'],
    Actions,
    typeof SET_MESSAGE_ACTIVE_LISTING_ID
  >(SET_MESSAGE_ACTIVE_LISTING_ID, payloadReducer, null),
  selectedListingDetails: handleAction<
    PermanentAddressMessage['selectedListingDetails'],
    Actions,
    typeof SET_MESSAGE_LISTING_DETAILS
  >(SET_MESSAGE_LISTING_DETAILS, payloadReducer, null),
  meta: metaReducer,
})
